import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-notas-despacho',
  templateUrl: './notas-despacho.component.html',
  styleUrls: ['./notas-despacho.component.scss']
})
export class NotasDespachoComponent implements OnInit {

  public titulo;
  public informacion;

  constructor(@Inject(MAT_DIALOG_DATA) private datos) { }

  ngOnInit() {
    if (this.datos.title == "N.Consulta") {
        this.titulo ="Notas Consultas"
    } else if (this.datos.title == "N.Operador"){
      this.titulo = "Notas Operador"
    }else {
      this.titulo = this.datos.title;
    }

    this.informacion = this.datos.info;
  }

}
